// extracted by mini-css-extract-plugin
module.exports = {"table-btn":"render-module_table-btn_1ZzRU","btn":"render-module_btn_2_Sfo","del-div":"render-module_del-div_14XL5"};